export const admissionSteps = [
  {
    step: "01",
    title: "상담 신청",
    desc: "전화 또는 온라인으로 상담을 신청해 주세요. 학생의 현재 상황과 목표를 먼저 듣겠습니다.",
    icon: "ri-chat-3-line",
  },
  {
    step: "02",
    title: "입학테스트",
    desc: "현재 실력을 정확히 진단하는 입학테스트를 진행합니다. 부담 없이 풀어보면 됩니다.",
    icon: "ri-file-list-3-line",
  },
  {
    step: "03",
    title: "학습 진단 상담",
    desc: "테스트 결과를 바탕으로 취약점과 학습 방향을 학부모님과 자세히 상담합니다.",
    icon: "ri-bar-chart-2-line",
  },
  {
    step: "04",
    title: "반 배정 · 학습 시작",
    desc: "수준과 목표에 맞는 반을 배정하고, 맞춤 커리큘럼으로 수업을 시작합니다.",
    icon: "ri-rocket-2-line",
  },
];

export const testSubjects = [
  {
    name: "초등부",
    detail: "연산 정확도 · 도형 감각 · 서술형 표현력을 중심으로 진단합니다.",
    icon: "ri-puzzle-line",
  },
  {
    name: "중등부",
    detail: "교과 개념 이해도와 유형 풀이력을 중심으로 진단합니다.",
    icon: "ri-function-line",
  },
  {
    name: "고등부",
    detail: "수Ⅰ·수Ⅱ·미적분의 개념 이해와 적용력을 중심으로 진단합니다.",
    icon: "ri-calculator-line",
  },
];

export const testPoints = [
  "테스트 비용은 무료입니다",
  "소요 시간은 약 60분입니다",
  "결과는 당일 학부모님께 리포트로 전달됩니다",
  "현재 학년에 구애받지 않고 실력 기준으로 진단합니다",
];

export const testImage =
  "https://readdy.ai/api/search-image?query=Minimalist%20bright%20studio%20photograph%20of%20a%20blank%20mathematics%20test%20paper%20with%20a%20pencil%20and%20eraser%20arranged%20neatly%20on%20a%20clean%20white%20desk%2C%20soft%20natural%20light%2C%20subtle%20pale%20green%20accents%2C%20editorial%20still%20life%20composition%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=1200&height=800&seq=mbhj-admission-test-01&orientation=landscape";